import { Component, OnInit } from '@angular/core';
import {ProductsService} from "../../../../../../services/products/products.service";
import {ActivatedRoute} from "@angular/router";
import {ToastrService} from "ngx-toastr";
import {Product} from "../../../../../../models/Product";

@Component({
  selector: 'app-prix-public',
  templateUrl: './prix-public.component.html',
  styleUrls: ['./prix-public.component.scss']
})
export class PrixPublicComponent implements OnInit {
    productId!: number;
    productData: any = {};
    constructor( private productsService : ProductsService,private route: ActivatedRoute, private toastr: ToastrService ) { }

    ngOnInit(): void {
        this.productId = +this.route.parent?.snapshot.paramMap.get('id')!;
        this.getProduct();
    }
    getProduct(): void {
        this.productsService.getDetailsProduct(this.productId).subscribe({
            next: (response: Product) => {
                this.productData = response;
                // console.log(this.productData);
            },
            error: (err) => {
                this.toastr.error('Erreur lors du chargement du produit');
            }
        });
    }
}
